import { Container, Header } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import VehicleRecallBanner from '../VehicleRecallBanner';
import styles from './VehicleRecallSearchPanel.module.css';

const cx = classnames.bind(styles);

export default function VehicleRecallSearchPanel({ children }) {
  const { t } = useTranslation('recalls');
  return (
    <Fragment>
      <VehicleRecallBanner>
        <Container className={cx('searchHeader')} fluid>
          <Header as="h1" color="white" uppercase elongated>
            {t('saveHeadache')}
          </Header>
          <Header as="h2" color="white" snug className={cx('subHeader')}>
            {t('checkForOpenRecalls')}
          </Header>
        </Container>
      </VehicleRecallBanner>
      {children}
    </Fragment>
  );
}

VehicleRecallSearchPanel.propTypes = {
  children: PropTypes.element,
};

VehicleRecallSearchPanel.defaultProps = {
  children: null,
};
